import { Box, DarkMode, Flex } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { createWidget } from '../widget-utils'

export interface OverlayWidgetProps {
  contentSlot?: ReactNode
  children?: ReactNode
}

export const OverlayWidget = ({
  children,
  contentSlot,
  ...props
}: OverlayWidgetProps) => {
  return (
    <Box {...props} position="relative">
      <Box
        mt="-16px"
        ml="-28px"
        mr="-28px"
        h="0"
        top="0"
        overflow="visible"
        bottom="calc(100vh + 28px)"
        zIndex="5"
        position="sticky"
      >
        <Flex
          bg="sidebar.bg"
          opacity=".9"
          height="100vh"
          justify="center"
          pt="40vh"
        >
          <DarkMode>
            <Box>{contentSlot}</Box>
          </DarkMode>
        </Flex>
      </Box>
      {children}
    </Box>
  )
}

export const OverlayWidgetDefinition = createWidget(OverlayWidget, {
  type: 'Overlay',
  slots: ['contentSlot'],
})
